/**
 * @file 인증 API
 * 로그인/로그아웃, 토큰 검증, 내 정보 조회, 비밀번호 변경 등을 처리합니다.
 */

import { api } from "../../../util/api";
import { API } from "../admin/api/endpoints";

export const authApi = {
    /**
     * 로그인 — 서버(AuthController.login)는 <b>{@code id} / {@code pw}</b> 두 키만 읽는다.
     *
     * <p>예전엔 여기서 {@code {loginId, password}} 를 보냈다. 서버가 못 읽어 둘 다 null 이 되니
     * 무조건 401 이 나는 함수였는데, 화면이 이 함수를 안 쓰고 직접 호출하고 있어서 아무도 몰랐다.
     * 로그인 경로가 둘이면 한쪽만 고쳐지므로 지금은 화면도 이 함수를 쓴다.
     */
    login:          (id, pw)            => api.post("/auth/login", { id, pw }),

    /** 로그아웃 */
    logout:         ()                  => api.post("/auth/logout"),

    /** 세션 연장 — 새 만료 시각을 {@code {expiration}} (millis) 으로 돌려준다. */
    extend:         ()                  => api.post("/auth/extend"),

    /* 토큰은 인자로 받지 않는다 — 서버가 X-TOKEN <b>헤더</b>만 읽고, 그 헤더는 http.js 의
     * 요청 인터셉터가 localStorage 에서 꺼내 자동으로 붙인다. 예전엔 body 에 token 을 실어 보냈지만
     * 서버는 쳐다보지도 않았다(헤더 덕에 우연히 동작). 안 쓰는 인자는 "이걸 바꾸면 뭔가 달라진다" 는
     * 착각을 남기므로 지운다. */
    /** 일반 사용자 토큰 검증 */
    verify:         ()                  => api.post("/auth/verify"),

    /** 관리자(GLOBAL_ADMIN) 토큰 검증 */
    verifyAdmin:    ()                  => api.post("/auth/verify_admin"),

    /** 현재 로그인한 사용자 정보 조회 */
    getMe:          ()                  => api.get(API.employees.me),

    /**
     * 비밀번호 변경 — 서버는 {@code oldPassword} / {@code newPassword} 를 읽는다.
     * 대상 계정은 <b>토큰에서 서버가 확정</b>하므로 email 은 보내지 않는다.
     */
    changePassword: (oldPassword, newPassword) =>
        api.post(API.employees.changePassword, { oldPassword, newPassword }),
};
